/**
 * Catálogo de tours — alimenta o "Rever tutoriais" da Ajuda.
 * Ao criar o tour de uma nova tela, importe o roteiro e adicione aqui.
 */
import { TOUR_VISAO_GERAL } from "./visaoGeral";

export const TOURS = [TOUR_VISAO_GERAL];
